export {
  AspectRatio,
  //
  Root,
} from './AspectRatio';
export type { AspectRatioProps } from './AspectRatio';
